import { Module, Mutation, VuexModule, Action } from 'vuex-module-decorators';

import container from '@/container';
import { EventsServiceContract, CONTRACTS } from '@/core/contracts';
import { ConnectionStatus } from '@/dto/ConnectionStatus';

const eventsService = container.get<EventsServiceContract>(CONTRACTS.EventsService);

interface ConnectionState {
    onlineStatus: ConnectionStatus;
}

@Module({ name: 'connectionStatus', namespaced: true })
export default class ConnectionStatusModule extends VuexModule implements ConnectionState {

    // -1 индикация отсутствует
    // 1 соединение установлено
    // 0 соединение разорвано
    // 3 временная потеря соединения
    // 2 выполняется попытка восстановить соединение
    private _onlineStatus: ConnectionStatus = ConnectionStatus.NotSet;

    get onlineStatus() {
        return this._onlineStatus;
    }

    @Action
    public async changeStatus(status: ConnectionStatus): Promise<any> {
        this.setStatus(status);
    }

    @Mutation
    private setStatus(status: ConnectionStatus) {
        this._onlineStatus = status;
    }
}
